export default {
  beforeMount(el, binding) {
    const updateValue = () => {
      const value = binding.value;
      const store = binding.instance.$store;
      const exchangeRates = store.getters["services/exchangeRates"];
      const currentCurrency = store.getters["services/currentCurrency"];

      if (!isNaN(value) && exchangeRates && exchangeRates[currentCurrency]) {
        const rate = exchangeRates[currentCurrency] || 1;
        const convertedValue = value * rate;

        try {
          const formatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currentCurrency,
            currencyDisplay: 'symbol'
          }).format(convertedValue);

          let formattedValue = currentCurrency === 'EUR'
            ? formatter.replace('€', '').trim() + ' €'
            : formatter.replace(/^([^\d]*)/, '$1 ');

          formattedValue = formattedValue.replace('US$', 'US $');
          el.innerHTML = formattedValue;
        } catch (error) {
          console.warn('Currency formatting error:', error);
          el.innerHTML = `${convertedValue.toFixed(2)} ${currentCurrency}`;
        }
      } else {
        el.innerHTML = `${value || 0} EUR`;
      }
    };

    updateValue();
    binding.instance.$watch(
      () => [
        binding.value,
        binding.instance.$store.getters["services/exchangeRates"],
        binding.instance.$store.getters["services/currentCurrency"]
      ],
      updateValue,
      { deep: false }
    );
  }
}